import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import type { EngineType } from "../../../../common-deprecated/types/CommonTypes";
import { getCommonOptionalLabel } from "../../../../common-deprecated/utils/commonLabels";

/**
 * Returns plugin label when the engine is a plugin
 * In all other cases returns the engine type
 */
export const getMotorizationEngineText = (commonSettings: CommonSettingsType, engine: EngineType): string => {
    const pluginLabel = getCommonOptionalLabel({ commonSettings }, "plugin");
    if (engine.plugin && pluginLabel) return pluginLabel as string;
    return engine.type;
};
